import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initializeAuth } from '../../firebase';
import { setNBMTMFavicon, restoreOriginalFavicon } from '../../utils/favicon';
import '../../App.css';
import './nbmtm.css';
import NBMTMLogo from './images/nbmtmlogo.svg';

export type ViewMode = 'AUTHORING' | 'VIEWING' | 'FILLINGOUT';

function NBMTMForm() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'NBMTM Operations';
    setNBMTMFavicon();
    return () => {
      restoreOriginalFavicon();
    };
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    let viewMode: ViewMode | null = null;
    
    if (password === process.env.REACT_APP_NBMTM_PASSWORD_AUTHORING) {
      viewMode = 'AUTHORING';
    } else if (password === process.env.REACT_APP_NBMTM_PASSWORD_VIEWING) {
      viewMode = 'VIEWING';
    } else if (password === process.env.REACT_APP_NBMTM_PASSWORD_FILLINGOUT) {
      viewMode = 'FILLINGOUT';
    }

    if (viewMode) {
      // Initialize Firebase auth only after password is verified
      initializeAuth();
      sessionStorage.setItem('nbmtm_authenticated', 'true');
      sessionStorage.setItem('nbmtm_view_mode', viewMode);
      navigate('/nbmtmops/secure');
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  return (
    <div className="App" style={{ 
      position: 'relative', 
      minHeight: '100dvh',
      backgroundImage: `url(${NBMTMLogo})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
      backgroundColor: '#282c34', // Ensuring we have the dark background
    }}>
      <header className="App-header" style={{ 
        position: 'relative',
        backgroundColor: 'rgba(40, 44, 52, 0.75)', // Adding some transparency to see the background
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <h1><span style={{ fontSize: '1.5em' }}>NBMTM</span><br />OPERATIONS</h1>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            autoComplete="new-password"
            style={{
              padding: '0.5rem',
              fontSize: '1rem',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
          <button
            type="submit"
            style={{
              padding: '0.5rem 1rem',
              fontSize: '1rem',
              backgroundColor: '#61dafb',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Enter
          </button>
          {error && <p style={{ color: '#ff6b6b' }}>{error}</p>}
        </form>
      </header>
    </div>
  );
}

export default NBMTMForm; 